import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthLoginRequest } from 'src/app/global/interfaces/auth-login-request';
import { AuthRequest } from 'src/app/global/interfaces/auth-request';
import { GeneralResponse } from 'src/app/global/interfaces/general-response';
import { AuthService } from 'src/app/global/services/auth.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthProvider extends AuthService {

  private api = environment.api;
  private endpoints = this.api.endpoints;

  constructor(private http: HttpClient) {
    super();
  }

  public auth(run: number, ci: string, tokenCaptcha: string, dispositivoMobile: boolean, idEjecutivo:number): Observable<GeneralResponse<any>> {
    const endpoint = this.api.host + this.api.path + this.endpoints.PASO_1.AUTH;
    const data: AuthRequest = {
      run,
      ci,
      tokenCaptcha,
      dispositivoMobile,
      idEjecutivo
    };
    return this.http.post<GeneralResponse<any>>(endpoint, data,
      // set header to let HTTP_INTERCEPTORS know to handle or not.
      { headers: { Anonymous: '' } });
  }

  public authLogin(run: number, correo: string, telefono: number, producto: string, tokenCaptcha: string, dispositivoMobile: boolean, idEjecutivo:number,isMarketplaceSVA:boolean): Observable<GeneralResponse<any>> {
    idEjecutivo = idEjecutivo!= null ? Number(idEjecutivo) : null;
    const endpoint = this.api.host + this.api.path + this.endpoints.PASO_1.loginCampania;
    const data: AuthLoginRequest = {
      run,
      telefono,
      correo,
      producto,
      tokenCaptcha,
      dispositivoMobile,
      idEjecutivo,
      marketplaceSVA:isMarketplaceSVA
    };
    return this.http.post<GeneralResponse<any>>(endpoint, data,{ headers: { Anonymous: '' } });
  }
}
